function determineIfCustomerIsBillboardCustomer(customer) {
  return customer?.is_billboard ?? false;
}

// DEPRECATED(customer-type-terms): this is_billboard-only branch predates the
// CustomerType/TenantConfig term ladder in hooks/relayLoadTerm.js
// (resolveSiteTerm/resolveSiteGroupTerm, consumed via useSiteTerm/
// useSiteGroupTerm) — it never sees a CustomerType override or a
// tenant-configured term, only the two hardcoded billboard/commercial i18n
// namespaces. Its three consumers (MapMarkerPopover, SiteDetailPanel,
// OperationsDashboardPage) sit outside the enumerated sweep for this change;
// migrate them to the hooks (or thread a resolved term prop through, where
// they lack a ScopeContext) as a follow-up so there is one authoritative term
// source.
export function getCustomerTerminologies(customer, t) {
  const ns = determineIfCustomerIsBillboardCustomer(customer) ? 'billboard' : 'commercial';
  if (t) {
    return {
      site: t(`terms.${ns}.site`, { defaultValue: ns === 'billboard' ? 'Structure' : 'Site' }),
      siteGroup: t(`terms.${ns}.siteGroup`, { defaultValue: ns === 'billboard' ? 'Plant' : 'Group' }),
      zone: t(`terms.${ns}.zone`, { defaultValue: ns === 'billboard' ? 'Panel' : 'Zone' }),
    };
  }
  return ns === 'billboard'
    ? { site: 'Structure', siteGroup: 'Plant', zone: 'Panel' }
    : { site: 'Site', siteGroup: 'Group', zone: 'Zone' };
}
